import { formatAppDateTime } from "../appTimeFormat";

export const MAX_FIXTURE_TAGS = 3;
export const FIXTURE_SECTION_WIDTH = 560;

const LIVE_STATUS_SHORTS = ['1H', '2H', 'HT', 'ET', 'P', 'BT', 'LIVE'];
const FINISHED_STATUS_SHORTS = ['FT', 'AET', 'PEN', 'ABD', 'AWD', 'WO', 'CANC', 'PST'];

export const fixtureRefId = (ref) =>
  ref?.fixtureId?.toString?.() || (typeof ref?.fixtureId === 'string' ? ref.fixtureId : null);

export const fixtureLabel = (ref) => {
  const home = ref?.homeTeam?.name || 'Home';
  const away = ref?.awayTeam?.name || 'Away';
  return `${home} vs ${away}`;
};

export const isFixtureLiveStatus = (ref) =>
  LIVE_STATUS_SHORTS.includes(ref?.status?.short);

export const isFixtureFinishedStatus = (ref) =>
  FINISHED_STATUS_SHORTS.includes(ref?.status?.short);

export const fixtureStatusShortCode = (ref) => ref?.status?.short || '—';

const formatKickoff = (timestamp) => {
  if (!timestamp) return 'Upcoming';
  return formatAppDateTime(Number(timestamp) * 1000);
};

export const fixtureStatusShortLabel = (ref) => {
  if (isFixtureLiveStatus(ref)) {
    const elapsed = ref?.status?.elapsed;
    return elapsed ? `LIVE ${elapsed}'` : 'LIVE';
  }
  if (isFixtureFinishedStatus(ref)) {
    return ref?.status?.short || 'FT';
  }
  if (ref?.timestamp) return formatKickoff(ref.timestamp);
  return 'Upcoming';
};

export const fixtureStatusLongLabel = (ref) => {
  const long = ref?.status?.long;
  if (long) return long;
  if (isFixtureLiveStatus(ref)) return 'Live';
  if (isFixtureFinishedStatus(ref)) return 'Finished';
  if (ref?.timestamp) return `Kickoff ${formatKickoff(ref.timestamp)}`;
  return 'Upcoming match';
};

export const fixtureScoreLabel = (ref) => {
  if (!isFixtureLiveStatus(ref) && !isFixtureFinishedStatus(ref)) return null;
  const h = ref?.goals?.home;
  const a = ref?.goals?.away;
  if (h == null || a == null) return null;
  return `${h} - ${a}`;
};

export const isTaggingActive = (text, cursorIndex = text.length) => {
  const before = text.slice(0, cursorIndex);
  return /(^|\s)@([\w.-]*)$/.test(before);
};

export const detectMentionQuery = (text, cursorIndex = text.length) => {
  const before = text.slice(0, cursorIndex);
  const match = before.match(/(^|\s)@([\w.-]{0,40})$/);
  if (!match) return null;
  const token = match[0];
  return { query: (match[2] || '').trim(), startIndex: before.length - token.length + match[1].length };
};

export const removeMentionToken = (text, cursorIndex = text.length) => {
  const before = text.slice(0, cursorIndex);
  const match = before.match(/(^|\s)@([\w.-]*)$/);
  if (!match) return { text, cursorIndex };
  const tokenLength = match[0].length - match[1].length;
  const start = before.length - tokenLength;
  const next = text.slice(0, start) + text.slice(cursorIndex);
  return { text: next, cursorIndex: start };
};

export const roomToFixtureRef = (room) => {
  const rawLeague = room?.league;
  const league =
    typeof rawLeague === "string"
      ? { name: rawLeague, logo: null }
      : rawLeague?.name
        ? { name: rawLeague.name, logo: rawLeague.logo || null }
        : null;
  return {
    fixtureId: room.fixtureId || room._id,
    homeTeam: room.homeTeam,
    awayTeam: room.awayTeam,
    league,
    status: room.status,
    goals: room.goals,
    timestamp: room.timestamp,
    round: room.round || null,
    venue: room.venue || null,
  };
};
